
<div class="p-0 m-0">
  <div class="header">
    <div class="left-header">
      <img
        src="~@/assets/img/arrow-back.svg"
        alt="SVG Icon"
        :style="{ cursor: 'pointer' }"
        @click="goBack"
      />
      <span>{{
        mode === "EDIT"
          ? $t("workspace_rde.rde_detail.label.edit_rde")
          : $t("workspace_rde.rde_detail.label.create_rde")
      }}</span>
    </div>

    <div class="right-header">
      <div v-if="adminAuth && mode === 'CREATE'" class="switch-v2-group">
        <Sw
          id="rde-input-create-user"
          v-model="values.showCreateUser"
          inset
          appendClass="switch-v2"
        ></Sw>
        <span class="text-switch">{{
          $t("workspace_rde.rde_detail.switch.create_user_group_rde")
        }}</span>
      </div>
      <Button :size="'md'" @click="goBack">
        {{ $t("common.base.button.cancel") }}
      </Button>
      <Button :type="'submit'" color="primary" :size="'md'" text fill>
        {{ $t("common.base.button.apply") }}
      </Button>
    </div>
  </div>
  <div class="rde-section">
    <div class="grid grid-cols-2">
      <Input
        id="rde-input-name"
        v-model="values.appName"
        :label="`* ${$t('workspace_rde.rde_detail.label.rde_name_12_char')}`"
        appendClass="input-text-field-v2"
        :rules="[
          rules.required,
          rules.name,
          mode !== 'EDIT' ? rules.maxLength(12) : () => true,
        ]"
        :disabled="mode === 'EDIT'"
      />
      <Input
        id="rde-input-display"
        v-model="values.displayName"
        :label="`* ${$t('common.base.label.display_name')}`"
        appendClass="input-text-field-v2"
        :rules="[rules.required]"
      />
    </div>

    <Input
      id="rde-input-description"
      v-model="values.description"
      :label="$t('common.base.label.description')"
      appendClass="input-text-field-v2"
    />
    <Select
      id="rde-input-namespace"
      v-model="values.namespace"
      :items="namespace_items"
      :rules="[rules.required]"
      :disabled="mode === 'EDIT'"
      :label="`* ${$t('common.base.label.namespace')}`"
      appendClass="select-v2"
      :solo="false"
      @input="handleChangeNamespace"
    ></Select>
    <div class="grid grid-cols-2">
      <InfraSelect
        id="rde-input-infra-select"
        :infraBaselineList="infraBaselineList"
        :values="values"
        :onChangeInfra="(obj) => onChangeInfraRDE(obj, true)"
        :defaultValue="defaultValueInfra"
      />
      <NumberInput
        id="rde-input-disk-size"
        v-model="values.diskSize.disk"
        :label="$t('workspace_rde.base.label.disk') + ' - GiB'"
        :format="'none'"
        appendClass="input-text-field-v2"
        :rules="[rules.required, maxDiskValidate]"
        :disabled="mode === 'EDIT'"
        :max="50"
      />
    </div>
    <div v-if="selectedFargateWs" class="switch-v2-group">
      <!-- *************** -->
      <Tooltip
        v-if="!allowSwitchFaragte"
        :text="$t('workspace_rde.rde_detail.tooltip.instance_type_locked')"
        position="right"
        targetSelf
      >
        <Sw
          :value="values.instanceType === 'fargate'"
          inset
          appendClass="switch-v2"
          :disabled="!allowSwitchFaragte"
          @input="toggleFargate"
        ></Sw>
        <span class="text-switch">Fargate</span>
      </Tooltip>
      <!-- ************** -->
      <Fragment v-else>
        <Sw
          :value="values.instanceType === 'fargate'"
          inset
          appendClass="switch-v2"
          @input="toggleFargate"
        ></Sw>
        <span class="text-switch">Fargate</span>
      </Fragment>
    </div>

    <div class="grid grid-cols-2 mt-1">
      <v-autocomplete
        v-if="!fargateMode"
        id="rde-input-target-node"
        :value="values.tolerations"
        :items="node_group_items_by_fargate"
        item-text="value"
        :item-value="mapValueNodeGroup"
        label="* Target Node"
        :placeholder="$t('workspace_rde.base.placeholder.target_node')"
        class="app-g-autocomplete-v2"
        :menu-props="{ contentClass: 'hide-check-box-auto-complete' }"
        clearable
        outlined
        dense
        :rules="[rules.required]"
        multiple
        @change="onChangeTargetNode"
      />
      <Select
        v-if="!fargateMode"
        id="rde-input-storage-type"
        v-model="values.diskSize.type"
        :items="storage_type_items"
        :rules="[rules.required]"
        :label="`* ${$t('workspace_rde.base.label.storage_type')}`"
        appendClass="select-v2"
        :disabled="mode === 'EDIT'"
        :solo="false"
      ></Select>
      <Input
        v-if="fargateMode"
        id="rde-input-fargate-key"
        v-model="values.fargate.key"
        :label="`* ${$t('workspace_rde.rde_detail.label.key')}`"
        appendClass="input-text-field-v2"
        :rules="[rules.required]"
      />
      <Input
        v-if="fargateMode"
        id="rde-input-fargate-value"
        v-model="values.fargate.value"
        :label="`* ${$t('workspace_rde.rde_detail.label.value')}`"
        appendClass="input-text-field-v2"
        :rules="[rules.required]"
      />
    </div>
  </div>
  <div v-if="values.serviceTypes" class="rde-section">
    <div class="rde-title">
      {{ $t("workspace_rde.rde_detail.label.service_type") }}
    </div>
    <div class="service-type">
      <div class="switch-v2-group">
        <Sw
          :value="values.serviceTypes.includes('vscode')"
          inset
          appendClass="switch-v2"
          :disabled="mode === 'EDIT'"
          @input="
            (value) =>
              setServiceTypes({ setValue, values, name: 'vscode', value })
          "
        ></Sw>
        <span class="text-switch">Visual Studio Code</span>
      </div>
      <div class="switch-v2-group">
        <Sw
          :value="values.serviceTypes.includes('webssh')"
          inset
          appendClass="switch-v2"
          :disabled="mode === 'EDIT'"
          @input="
            (value) =>
              setServiceTypes({ setValue, values, name: 'webssh', value })
          "
        ></Sw>
        <span class="text-switch">SSH</span>
      </div>
      <div class="switch-v2-group">
        <Sw
          :value="values.serviceTypes.includes('notebook')"
          inset
          appendClass="switch-v2"
          :disabled="mode === 'EDIT'"
          @input="
            (value) =>
              setServiceTypes({
                setValue,
                values,
                name: 'notebook',
                value,
              })
          "
        ></Sw>
        <span class="text-switch">Jupyter</span>
      </div>
    </div>
    <div v-if="!values.serviceTypes.length" class="text-xs text-error h-5">
      {{ $t("workspace_rde.rde_detail.message.require_service") }}
    </div>
  </div>
  <div v-if="values.serviceTypes.includes('vscode')" class="rde-section">
    <div class="rde-title">
      {{ $t("workspace_rde.rde_detail.label.ide_type") }}
    </div>
    <v-btn-toggle
      v-model="values.vscode.ideTypes"
      class="mt-2"
      dense
      variant="outlined"
      color="primary accent-3"
      multiple
      divided
    >
      <v-btn value="web"> Web </v-btn>
      <v-btn value="ssh"> SSH </v-btn>
    </v-btn-toggle>

    <div
      v-if="!values.vscode.ideTypes.length"
      class="text-xs text-error h-5 mt-1"
    >
      {{ $t("common.base.label.required") }}
    </div>

    <!-- <div v-if="showSshOnlyError" class="text-xs text-error h-5">
      VS Code - SSH only is not supported
    </div> -->
  </div>
  <div class="rde-section">
    <div class="rde-title">
      {{ $t("workspace_rde.rde_detail.label.port_list") }}
    </div>
    <AddPortInputListV2
      :portList="values.portList"
      @change="
        (newPorts) => {
          setValue('portList', newPorts);
        }
      "
    />
  </div>
  <div class="rde-section">
    <div class="switch-v2-group gap-2">
      <div class="rde-title">
        {{ $t("workspace_rde.rde_detail.label.install_packages") }}
      </div>
      <Sw
        id="rde-input-install-packages-sw"
        v-model="values.useInstallPackages"
        inset
        appendClass="switch-v2"
      ></Sw>
    </div>
    <transition name="fade" mode="out-in">
      <InstallPackage
        v-if="values.useInstallPackages === true"
        :values="values"
        :setValue="setValue"
        :installPackages="installPackages"
        :validate="validate"
      />
    </transition>
  </div>
  <div
    v-if="values.serviceTypes && values.serviceTypes.includes('vscode')"
    key="vscode"
    class="rde-section"
  >
    <div class="rde-title">
      {{ $t("workspace_rde.rde_detail.label.vscode_setting") }}
    </div>
    <VSCodeInput
      :values="values"
      :set-value="setValue"
      :showImageCheckbox="imageVsCodeEnabled"
      :defaultValues="defaultValues"
    />

    <CustomMultiSelectRde
      v-if="values.vscode.useImage && imageVsCodeEnabled"
      key="vscode-image-web"
      :default-value="defaultValues.vscode"
      :set-value="(obj) => setImage('vscode', obj)"
      :label="$t('workspace_rde.rde_detail.placeholder.select_image')"
      :items="images.vscode"
      :placeholder="$t('workspace_rde.rde_detail.placeholder.select_image')"
      class="app-g-autocomplete-v2"
      multiple
      outlined
      dense
    />

    <InfraSizeInput
      serviceType="vscode"
      :values="values"
      :requirementInfraResource="guideInfraResource?.requirements"
      :validate="validate"
      :setValue="setValue"
      :gpuAvailable="workspace?.gpuAvailable"
      @value-change="infraSizeChange"
    />
  </div>

  <div
    v-if="values.serviceTypes && values.serviceTypes.includes('webssh')"
    key="webssh"
    class="rde-section"
  >
    <div class="rde-title">
      {{ $t("workspace_rde.rde_detail.label.web_ssh_setting") }}
    </div>
    <Checkbox
      v-if="images?.webssh?.length > 0"
      v-model="values.webssh.useImage"
      label="Image"
    />
    <CustomMultiSelectRde
      v-if="values.webssh.useImage && imageWebsshEnabled"
      :default-value="defaultValues.webssh"
      :set-value="(obj) => setImage('webssh', obj)"
      :label="$t('workspace_rde.rde_detail.placeholder.select_image')"
      :items="images.webssh"
      :placeholder="$t('workspace_rde.rde_detail.placeholder.select_image')"
      class="app-g-autocomplete-v2"
      multiple
      outlined
      dense
    />
    <InfraSizeInput
      serviceType="webssh"
      :values="values"
      :requirementInfraResource="guideInfraResource?.requirements"
      :validate="validate"
      :setValue="setValue"
      :gpuAvailable="workspace?.gpuAvailable"
      @value-change="infraSizeChange"
    />
  </div>

  <div
    v-if="values.serviceTypes && values.serviceTypes.includes('notebook')"
    key="notebook"
    class="rde-section"
  >
    <div class="rde-title">
      {{ $t("workspace_rde.rde_detail.label.jupyter_setting") }}
    </div>
    <Checkbox
      v-if="images.jupyter?.length > 0"
      v-model="values.notebook.useImage"
      label="Image"
    />
    <CustomMultiSelectRde
      v-if="values.notebook.useImage && images.jupyter?.length > 0"
      :default-value="defaultValues.notebook"
      :set-value="(obj) => setImage('notebook', obj)"
      label="Image"
      :items="images.jupyter"
      :placeholder="$t('workspace_rde.rde_detail.placeholder.select_image')"
      class="app-g-autocomplete-v2"
      multiple
      outlined
      dense
    />
    <!-- <Checkbox
      v-if="!!images.notebook.length"
      v-model="values.notebook.useImage"
      label="Image"
    />
    <v-autocomplete
      v-if="values.notebook.useImage && !!images.notebook.length"
      v-model="values.notebook.image"
      :items="images.notebook"
      label="Image"
      small-chips
      placeholder="Select Image"
      class="app-g-autocomplete-v2"
      clearable
      outlined
      dense
    /> -->
    <InfraSizeInput
      serviceType="notebook"
      :values="values"
      :requirementInfraResource="guideInfraResource?.requirements"
      :validate="validate"
      :setValue="setValue"
      :gpuAvailable="workspace?.gpuAvailable"
      @value-change="infraSizeChange"
    />
  </div>

  <div v-if="values.showCreateUser" class="rde-section">
    <div class="rde-title">
      {{ $t("workspace_rde.rde_detail.label.create_multiple_rde") }}
    </div>
    <UserInput
      :values="values"
      :setValue="setValue"
      :projectId="workspace?.projectId"
      mapFields="selectedUsers"
      :accountInfo="accountInfo"
    />
  </div>
</div>
